/* Mega menu visual (Teste 28.0, implementado em 20/10/2026)
   Mobile: rewrites the content of the theme drawer #menu_mobile (open/close stay with the theme).
   Desktop: replaces the Headphones / Earphones / Acessórios items of #hdt-nav-ul with panel triggers.
   Search: never renders its own search; it clicks the drawer's own 'Pesquisar' link (aria-controls="drawer-search-form"). */
(function () {
  if (window.__kmm) return;
  window.__kmm = true;
  var D = document, H = D.documentElement;
  H.classList.add('kmm-on');

  var CDN = 'https://cdn.shopify.com/s/files/1/0792/7614/7003/files/';
  var SHOP = '/cdn/shop/files/';
  function im(u, crop) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=320&height=320&crop=' + (crop || 'center'); }

  var P = {
    mali: { h: 'mali-2', n: 'Mali 2', sel: 'Mais vendido', d: 'Bluetooth 6.0 com cancelamento de ruído', r: 4.8, img: im(CDN + 'mali-stills-2.jpg?v=1790087133'), hov: CDN + 'Maintain_every_aspect_of_the_p_Nano_Banana_2_57040.jpg?v=1784738874&crop=region&crop_left=397&crop_top=266&crop_width=679&crop_height=679&width=320&height=320' }, // Mali 2 card hover on the home (focus 39/45), 10% closer than its 180% zoom
    auri: { h: 'auri', n: 'Auri', sel: 'Lançamento', d: 'Saída USB-C com o som dos clientes', img: im(CDN + 'Earphones_with_audio_cable_202608061448.jpeg_202608061450_1000b250-0cc7-48a7-b7ae-3375bf3cd004.png?v=1787845112'), hov: im(SHOP + '5_82930fc2-e82d-43f4-b4a1-8f37de46d1e0.jpg?v=1789569881', 'top') },
    uni: { h: 'uni', n: 'Uni', d: 'Saída P2 com ou sem microfone', r: 4.7, img: im(CDN + 'uni-still-1.jpg?v=1790087407'), hov: im(SHOP + '1-03.webp?v=1789574389', 'top') },
    d2bt: { h: 'disco-2-bluetooth', n: 'Disco 2 Bluetooth', sel: 'Mais vendido', d: 'Suas músicas com ou sem fio', r: 4.9, img: im(CDN + 'kuba-disco-2-bluetooth-tauari-2025-01.jpg?v=1736877103'), hov: im(SHOP + '1-11.webp?v=1789574389', 'top') },
    d2c: { h: 'disco-2-classico', n: 'Disco 2 Clássico', d: 'Suas músicas em alta fidelidade', r: 4.9, img: im(CDN + 'Headphone-Highend-Kuba-Disco-2-Classico-Tauari-2025-1.jpg?v=1738954882'), hov: im(SHOP + '1-10.webp?v=1789574388', 'top') },
    d2p: { h: 'disco-2-pro', n: 'Disco 2 Pro', d: 'Referência para home studio', r: 4.9, img: im(SHOP + 'Disco-2-Pro-card-sem-linha.jpg?v=1790972260', 'top'), hov: im(SHOP + '6.jpg?v=1742909809', 'top') },
    nia: { h: 'nia', n: 'Nia', d: 'O mais leve da linha', r: 4.7, img: im(CDN + 'kuba-nia-headset-1.jpg?v=1736785185'), hov: im(SHOP + '1-08.webp?v=1789574389', 'top') },
    dac: { h: 'adaptador-usb-c-dac-amplificador-kd-1', n: 'Adaptador USB-C com DAC', d: 'Mais qualidade na saída do celular para fones com fio', img: im(CDN + 'kd1.1.png?v=1790881805'), hov: im(CDN + 'adaptador-usbc-dac-amp-headphone.jpg?v=1741295585', 'top') },
    ovomicro: { h: 'case-ovo-micro', n: 'Case Ovo Micro', d: 'Case rígida para proteger o Mali, Auri ou Uni', img: im(CDN + 'Case-micro-2026-01_3b7905d2-29fd-4e42-95fd-4bfbb4addbdb.png?v=1790878724'), hov: im(CDN + 'Case-micro-2026-02.png?v=1790800636', 'top') },
    cabohs: { h: 'cabo-headset', n: 'Cabo Headset', d: 'Transforma o Disco ou o Nia em headset', img: im(CDN + 'cabo-headset-kuba.jpg?v=1730993698'), hov: im(CDN + 'Headphone-Disco-2-Pro-Cabo-Headset.jpg?v=1738945492', 'top') },
    almxl: { h: 'almofada-xl', n: 'Almofadas XL', d: 'Mais isolamento e graves no Disco e no Nia', img: im(CDN + 'par-almofadas-xl.jpg?v=1730986751'), hov: im(CDN + 'par-almoafadas-xl.jpg?v=1730986798', 'top') }
  };
  var CAT = {
    head: { label: 'Headphones', url: '/collections/headphones', items: ['d2bt', 'd2c', 'd2p', 'nia'], quiz: 'Qual headphone é o seu?', cta: 'Ver mais', ctaLabel: 'Ver mais sobre os headphones' },
    ear: { label: 'Earphones', url: '/collections/intra-auriculares', items: ['mali', 'auri', 'uni'], quiz: 'Qual earphone é o seu?', cta: 'Ver mais', ctaLabel: 'Ver mais sobre os earphones' },
    acc: { label: 'Acessórios', url: '/collections/acessorios', items: ['dac', 'ovomicro', 'cabohs', 'almxl'], cta: 'Ver todos', ctaLabel: 'Ver todos os acessórios' }
  };
  var TAB_ORDER = ['ear', 'head', 'acc'];     // mobile chips
  var NAV_ORDER = ['head', 'ear', 'acc'];     // desktop header order
  var QUIZ_HASH = 'ajuda';                      // the quiz section on each category page
  var ARROW = '<i aria-hidden="true"></i>';
  var TRUST = '<span class="kmm-trust kmm-label"><i>✓</i> Frete grátis a partir de R$ 199</span><span class="kmm-trust kmm-label"><i>✓</i> 6x sem juros</span>';
  var CHEV = '<svg viewBox="0 0 10 7" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>';
  var SEARCH_ICO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/></svg>';

  /* ---------- prices: live from the storefront, cached for the session ---------- */
  var PRICE = {};
  function money(v) { return 'R$ ' + v.toLocaleString('pt-BR', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }); }
  function parcel(v) { return 'ou 6x de ' + (Math.round(v / 6 * 100) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) + ' sem juros'; }
  function priceHtml(x) {
    if (!x) return '';
    return '<div class="kmm-price__l1">' + (x.from ? '<span class="kmm-price__from">a partir de</span>' : '') +
      '<span class="kmm-price__now">' + money(x.p) + '</span>' + (x.c ? '<span class="kmm-price__was">' + money(x.c) + '</span>' : '') + '</div>' +
      (x.p >= 100 ? '<span class="kmm-price__parc">' + parcel(x.p) + '</span>' : '');
  }
  function getPrice(k) {
    if (PRICE[k]) return Promise.resolve(PRICE[k]);
    var key = 'kmm:p:' + P[k].h, c = null;
    try { c = JSON.parse(sessionStorage.getItem(key)); } catch (e) {}
    if (c) { PRICE[k] = c; return Promise.resolve(c); }
    return fetch('/products/' + P[k].h + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j) return null;
        var v = { p: j.price / 100, from: !!j.price_varies, c: null };
        if (!v.from && j.compare_at_price && j.compare_at_price > j.price) v.c = j.compare_at_price / 100;
        PRICE[k] = v;
        try { sessionStorage.setItem(key, JSON.stringify(v)); } catch (e) {}
        return v;
      }).catch(function () { return null; });
  }
  function fillPrices(root) {
    [].forEach.call(root.querySelectorAll('.kmm-price[data-k]:not([data-done])'), function (el) {
      el.setAttribute('data-done', '');
      getPrice(el.getAttribute('data-k')).then(function (v) { el.innerHTML = priceHtml(v); });
    });
  }
  function loadImgs(root) {
    [].forEach.call(root.querySelectorAll('img[data-src]'), function (i) { i.src = i.getAttribute('data-src'); i.removeAttribute('data-src'); });
  }

  /* ---------- shared bits ---------- */
  function badge(x) { return x.sel ? '<span class="kmm-badge' + (x.sel === 'Lançamento' ? ' kmm-badge--alt' : '') + '">' + x.sel + '</span>' : ''; }
  function stars(x) {
    if (x.pre) return '<span class="kmm-label">Pré-venda</span>';
    if (!x.r) return '';
    return '<span class="kmm-stars"><i aria-hidden="true">★★★★★</i>' + x.r.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + '</span>';
  }
  function url(x) { return '/products/' + x.h; }

  /* ---------- mobile drawer ---------- */
  function catOfPage() {
    var p = location.pathname;
    for (var c in CAT) {
      if (p.indexOf(CAT[c].url) === 0) return c;
      for (var i = 0; i < CAT[c].items.length; i++) if (p === url(P[CAT[c].items[i]])) return c;
    }
    // Other product pages: use the product type Shopify publishes on the page.
    var t = '';
    try { t = window.ShopifyAnalytics.meta.product.type || ''; } catch (e) {}
    if (/acess/i.test(t)) return 'acc';
    if (/headphone/i.test(t)) return 'head';
    if (/intra|earphone/i.test(t)) return 'ear';
    return 'ear';
  }
  function mobileRow(k) {
    var x = P[k];
    return '<a class="kmm-row" href="' + url(x) + '"><div class="kmm-row__img"><img alt="" data-src="' + x.img + '"></div>' +
      '<div class="kmm-row__body"><span class="kmm-row__name">' + x.n + badge(x) + '</span>' + stars(x) +
      '<span class="kmm-row__frase">' + x.d + '</span><div class="kmm-price" data-k="' + k + '"></div></div></a>';
  }
  function mobilePane(c) {
    var C = CAT[c];
    return '<div class="kmm-pane" role="tabpanel" data-pane="' + c + '" hidden>' + C.items.map(mobileRow).join('') +
      '<a class="kmm-btn kmm-btn--red kmm-cta" href="' + C.url + '" aria-label="' + C.ctaLabel + '">' + C.cta + ARROW + '</a>' +
      (C.quiz ? '<a class="kmm-quiz" href="' + C.url + '#' + QUIZ_HASH + '"><b>' + C.quiz + '</b><span>Responda 3 perguntas sobre uso, conexão e orçamento.</span><span class="kmm-go kmm-label">Me ajude a escolher' + ARROW + '</span></a>' : '') +
      '</div>';
  }
  function buildMobile(m) {
    if (m.querySelector('.kmm-m')) return m.querySelector('.kmm-m');
    var logo = D.querySelector('.hdt-logo img');
    var logoHtml = logo ? '<img alt="Kuba Audio" src="' + (logo.currentSrc || logo.src) + '">' : '<span>KUBA</span>';
    var box = D.createElement('div');
    box.className = 'kmm kmm-m';
    box.innerHTML =
      '<div class="kmm-m__top"><button type="button" class="kmm-m__x" aria-label="Fechar menu">×</button><a class="kmm-m__logo" href="/">' + logoHtml + '</a><span></span></div>' +
      '<div class="kmm-m__head"><button type="button" class="kmm-search">' + SEARCH_ICO + 'Buscar fones e peças</button>' +
      '<div class="kmm-tabs" role="tablist">' + TAB_ORDER.map(function (c) { return '<button type="button" role="tab" class="kmm-tab" aria-selected="false" data-tab="' + c + '">' + CAT[c].label + '</button>'; }).join('') + '</div></div>' +
      '<div class="kmm-m__body">' + TAB_ORDER.map(mobilePane).join('') +
      '<nav class="kmm-sec"><a href="/products/kuba-tala">Caixa de Som</a><a href="/pages/suporte">Suporte</a><a href="/pages/para-empresas">Para Empresas</a><a href="/account" rel="nofollow">Login</a></nav></div>' +
      '<div class="kmm-m__foot">' + TRUST + '</div>';
    m.appendChild(box);
    box.querySelector('.kmm-m__x').addEventListener('click', function () { closeDrawer(m); });
    box.querySelector('.kmm-search').addEventListener('click', function () { openSearch(m); });
    [].forEach.call(box.querySelectorAll('.kmm-tab'), function (b) { b.addEventListener('click', function () { setTab(box, b.getAttribute('data-tab')); }); });
    return box;
  }
  function setTab(box, c) {
    [].forEach.call(box.querySelectorAll('.kmm-tab'), function (b) { b.setAttribute('aria-selected', String(b.getAttribute('data-tab') === c)); });
    [].forEach.call(box.querySelectorAll('.kmm-pane'), function (p) { p.hidden = p.getAttribute('data-pane') !== c; });
    var pane = box.querySelector('[data-pane="' + c + '"]');
    loadImgs(pane); fillPrices(pane);
    box.querySelector('.kmm-m__body').scrollTop = 0;
  }
  // The theme resolves closeDialog() on 'dialog:afterClose', which does not always fire; never wait more than 450ms.
  function closeDrawer(m) {
    if (!m || !m.closeDialog) return Promise.resolve();
    return Promise.race([Promise.resolve(m.closeDialog()), new Promise(function (r) { setTimeout(r, 450); })]);
  }
  // Same path as the control: click the theme's own "Pesquisar" link of the drawer (aria-controls="drawer-search-form"),
  // so the search drawer opens over the menu and closing it returns to the menu. Falls back to the header icon, then /search.
  function openSearch(m) {
    var target = D.querySelector('#menu_mobile a[aria-controls="drawer-search-form"]') ||
      [].filter.call(D.querySelectorAll('a[aria-controls="drawer-search-form"]'), function (a) { return a.offsetParent !== null; })[0];
    if (!target) { location.href = '/search'; return; }
    window.__kbSearchFrom = 'menu';
    target.click();
    setTimeout(function () { window.__kbSearchFrom = null; }, 0);
  }
  // The cookie banner (Pandectes) sits over the bottom of the screen until answered: reserve its height so the end of the menu stays reachable.
  function fitCookieBanner(box) {
    var b = D.querySelector('#pandectes-banner .cc-window'), h = 0;
    if (b && !/cc-invisible/.test(b.className) && getComputedStyle(b).display !== 'none' && getComputedStyle(b).visibility !== 'hidden') {
      var r = b.getBoundingClientRect();
      if (r.height > 0 && r.top < innerHeight) h = Math.ceil(innerHeight - r.top);
    }
    box.style.setProperty('--kmm-cookie', h + 'px');
  }
  function onDrawerOpen() {
    var m = D.getElementById('menu_mobile');
    if (!m) return;
    var box = buildMobile(m);
    setTab(box, catOfPage());
    fitCookieBanner(box);
  }
  D.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#pandectes-banner')) setTimeout(function () { var box = D.querySelector('.kmm-m'); if (box) fitCookieBanner(box); }, 450);
  }, true);

  /* ---------- desktop panel ---------- */
  var OPEN_MS = 200, SWITCH_MS = 100, CLOSE_MS = 300, LEAVE_MS = 160;
  var state = { cur: null, openT: null, closeT: null, leaveT: null };
  var panel, zone, triggers = {};

  function card(k) {
    var x = P[k];
    return '<a class="kmm-card" href="' + url(x) + '"><div class="kmm-card__img"><img alt="" data-src="' + x.img + '">' +
      (x.hov ? '<img class="kmm-card__hover" alt="" data-src="' + x.hov + '">' : '') + badge(x) + '</div>' +
      '<div class="kmm-card__body"><span class="kmm-card__name">' + x.n + '</span>' + stars(x) + '<span class="kmm-card__frase">' + x.d + '</span>' +
      '<div class="kmm-price" data-k="' + k + '"></div><span class="kmm-go kmm-label kmm-card__go">Conheça' + ARROW + '</span></div></a>';
  }
  function panelInner(c) {
    var C = CAT[c];
    var aside = C.quiz
      ? '<div class="kmm-aside"><b>' + C.quiz + '</b><p>Responda 3 perguntas sobre uso, conexão e orçamento e veja a indicação.</p>' +
        '<a class="kmm-btn kmm-btn--red" href="' + C.url + '" aria-label="' + C.ctaLabel + '">' + C.cta + ARROW + '</a>' +
        '<a class="kmm-btn kmm-btn--ghost kmm-quiz-btn" href="' + C.url + '#' + QUIZ_HASH + '">Me ajude a escolher</a>' +
        '<div class="kmm-aside__trust">' + TRUST + '</div></div>'
      : '<div class="kmm-aside"><b>Peças para toda a linha</b><p>Arcos, cabos, almofadas e conchas para trocar só o que precisa.</p>' +
        '<a class="kmm-btn kmm-btn--red" href="' + C.url + '" aria-label="' + C.ctaLabel + '">' + C.cta + ARROW + '</a>' +
        '<div class="kmm-aside__trust">' + TRUST + '</div></div>';
    return '<div class="kmm-panel__in" data-cat="' + c + '" style="grid-template-columns:repeat(' + C.items.length + ',minmax(0,1fr)) 292px">' + C.items.map(card).join('') + aside + '</div>';
  }
  function setExpanded(c) { for (var k in triggers) triggers[k].setAttribute('aria-expanded', String(k === c)); }
  function hydrate(node) { loadImgs(node); fillPrices(node); }
  function clearTimers() { clearTimeout(state.openT); clearTimeout(state.closeT); state.openT = state.closeT = null; }
  function openPanel(c) {
    if (c === state.cur && !state.leaveT) return;
    clearTimeout(state.leaveT); state.leaveT = null;
    panel.classList.remove('is-leaving');
    if (state.cur && !panel.hidden) { switchPanel(state.cur, c); return; }
    panel.innerHTML = panelInner(c);
    panel.style.height = '';
    panel.hidden = false;
    panel.classList.remove('is-enter'); void panel.offsetWidth; panel.classList.add('is-enter');
    hydrate(panel);
    state.cur = c; setExpanded(c);
  }
  function switchPanel(from, to) {
    [].forEach.call(panel.querySelectorAll('.kmm-panel__in.is-out'), function (n) { n.remove(); });
    panel.classList.remove('is-enter');
    var oldIn = panel.querySelector('.kmm-panel__in');
    var dir = NAV_ORDER.indexOf(to) > NAV_ORDER.indexOf(from) ? 1 : -1;
    var h0 = panel.offsetHeight;
    var tmp = D.createElement('div'); tmp.innerHTML = panelInner(to);
    var newIn = tmp.firstElementChild;
    panel.style.setProperty('--kmm-dir', dir);
    panel.style.height = h0 + 'px';
    if (oldIn) oldIn.classList.add('is-out');
    newIn.classList.add('is-in');
    panel.appendChild(newIn);
    hydrate(newIn);
    var h1 = newIn.offsetHeight;
    requestAnimationFrame(function () { panel.style.height = h1 + 'px'; });
    state.cur = to; setExpanded(to);
    clearTimeout(panel._swT);
    panel._swT = setTimeout(function () { if (oldIn) oldIn.remove(); newIn.classList.remove('is-in'); panel.style.height = ''; }, 280);
  }
  function closePanel() {
    if (!state.cur || state.leaveT) return;
    panel.classList.add('is-leaving');
    setExpanded(null);
    state.leaveT = setTimeout(function () {
      state.leaveT = null; state.cur = null;
      panel.hidden = true; panel.classList.remove('is-leaving', 'is-enter'); panel.innerHTML = ''; panel.style.height = '';
    }, LEAVE_MS);
  }
  function buildDesktop() {
    var ul = D.getElementById('hdt-nav-ul');
    zone = D.querySelector('hdt-sticky-header');
    if (!ul || !zone || zone.querySelector('.kmm-panel')) return;
    [].forEach.call(ul.children, function (li) {
      var s = li.querySelector('summary[data-url]'), a = li.querySelector('a#hdt-menu-acessorios'), c = null, label = '', cls = '';
      if (s) { c = s.getAttribute('data-url') === '/collections/headphones' ? 'head' : (s.getAttribute('data-url') === '/collections/intra-auriculares' ? 'ear' : null); label = s.textContent.trim(); cls = s.className; }
      else if (a) { c = 'acc'; label = a.textContent.trim(); cls = a.className; }
      if (!c) return;
      li.classList.remove('hdt-has-children');
      // The title stays a link to its category page (same as the control); resting the cursor on it opens the panel.
      li.innerHTML = '<a href="' + CAT[c].url + '" class="' + cls + ' kmm-trig" data-kmm="' + c + '" aria-haspopup="true" aria-expanded="false"><span class="hdt-menu-link-text hdt-block">' + label + '</span>' + CHEV + '</a>';
      triggers[c] = li.querySelector('.kmm-trig');
    });
    panel = D.createElement('div');
    panel.className = 'kmm kmm-panel';
    panel.hidden = true;
    zone.appendChild(panel);

    D.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('.kmm-trig');
      if (t) { clearTimers(); return; } // let the link take the visitor to the category page
      if (state.cur && !(e.target.closest && e.target.closest('.kmm-panel'))) { clearTimers(); closePanel(); }
    });
    D.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.cur) { clearTimers(); closePanel(); } });
    // Keyboard: tabbing onto a title opens its panel, so the cards stay reachable without a mouse.
    D.addEventListener('focusin', function (e) {
      var t = e.target.closest && e.target.closest('.kmm-trig');
      if (t && t.matches(':focus-visible')) { clearTimers(); openPanel(t.getAttribute('data-kmm')); }
      else if (state.cur && !(e.target.closest && (e.target.closest('.kmm-panel') || e.target.closest('#hdt-nav-ul')))) { clearTimers(); closePanel(); }
    });
    D.addEventListener('mouseover', function (e) {
      if (!window.matchMedia('(min-width: 1150px)').matches) return;
      var t = e.target.closest && e.target.closest('.kmm-trig');
      var inZone = e.target.closest && (e.target.closest('.kmm-panel:not(.is-leaving)') || e.target.closest('#hdt-nav-ul'));
      clearTimeout(state.openT); state.openT = null;
      if (inZone) { clearTimeout(state.closeT); state.closeT = null; }
      else if (state.cur && !state.closeT && !state.leaveT) { state.closeT = setTimeout(function () { state.closeT = null; closePanel(); }, CLOSE_MS); }
      if (t) {
        var c = t.getAttribute('data-kmm');
        if (c !== state.cur || state.leaveT) {
          state.openT = setTimeout(function () { state.openT = null; openPanel(c); }, state.cur && !state.leaveT ? SWITCH_MS : OPEN_MS);
        }
      }
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    buildDesktop();
    // Already on that category page: a same-page hash link would leave the menu open over the quiz, so close it and scroll instead.
    D.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.kmm-quiz, a.kmm-quiz-btn');
      if (!a) return;
      if (a.pathname !== location.pathname) { try { sessionStorage.setItem('kmm:quiz', '1'); } catch (x) {} return; }
      var target = D.getElementById(QUIZ_HASH);
      if (!target) return;
      e.preventDefault();
      var go = function () { history.replaceState(null, '', '#' + QUIZ_HASH); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
      if (a.closest('#menu_mobile')) closeDrawer(D.getElementById('menu_mobile')).then(go);
      else { clearTimers(); closePanel(); go(); }
    });
    // Arrived from the menu's quiz button: the browser jumps to #ajuda before the content above it finishes loading and pushes it down.
    // Re-align once the page settles, unless the visitor has already scrolled on their own.
    var fromQuiz = false;
    try { fromQuiz = sessionStorage.getItem('kmm:quiz') === '1'; sessionStorage.removeItem('kmm:quiz'); } catch (x) {}
    if (fromQuiz && location.hash === '#' + QUIZ_HASH) {
      var moved = false, stop = function () { moved = true; };
      ['wheel', 'touchstart', 'keydown'].forEach(function (t) { addEventListener(t, stop, { once: true, passive: true }); });
      var settle = function () {
        var t = D.getElementById(QUIZ_HASH);
        if (!moved && t && Math.abs(t.getBoundingClientRect().top) > 120) t.scrollIntoView({ block: 'start', behavior: 'instant' });
      };
      if (D.readyState === 'complete') setTimeout(settle, 300); else addEventListener('load', function () { setTimeout(settle, 300); });
    }
    D.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.hdt-push-menu-btn')) setTimeout(onDrawerOpen, 0);
    }, true);
    var m = D.getElementById('menu_mobile');
    if (m) new MutationObserver(function () { if (m.hasAttribute('open')) onDrawerOpen(); }).observe(m, { attributes: true, attributeFilter: ['open'] });
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* Intercom: botão de ajuda à esquerda em toda a loja, acima do que estiver fixo no rodapé
   à esquerda (aviso de cookies até a pessoa fechar, barra de compra, barra do pedido da Black) */
(function () {
  var last = null;
  // no celular o Intercom ignora vertical_padding: a altura vai também por CSS
  var st = document.createElement('style');
  st.textContent = '.intercom-lightweight-app-launcher, iframe.intercom-launcher-frame, iframe[name="intercom-launcher-frame"] { bottom: var(--kb-ic-pad, 20px) !important; left: 20px !important; right: auto !important; }';
  document.head.appendChild(st);
  function isIntercom(n) { return /intercom/i.test((n.className && n.className.toString()) + ' ' + (n.id || '') + ' ' + (n.getAttribute && n.getAttribute('name') || '')); }
  function place() {
    var vh = window.innerHeight, top = vh;
    [[44, vh - 30], [44, vh - 70]].forEach(function (p) {
      document.elementsFromPoint(p[0], p[1]).forEach(function (el) {
        for (var n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
          if (isIntercom(n)) return;
          var cs = getComputedStyle(n);
          if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
          var r = n.getBoundingClientRect();
          // só barras/avisos presos embaixo (não gavetas e janelas de tela cheia)
          if (r.top > vh * 0.4 && r.bottom >= vh - 40 && cs.visibility !== 'hidden' && +cs.opacity > 0) top = Math.min(top, r.top);
          return;
        }
      });
    });
    var pad = top < vh ? Math.round(vh - top) + 12 : 20;
    // o Intercom carrega depois e sobe na posição padrão: reaplica enquanto o botão estiver no lado errado
    var btn = document.querySelector('.intercom-lightweight-app-launcher, iframe[name="intercom-launcher-frame"]');
    var wrong = btn && btn.getBoundingClientRect().left > window.innerWidth / 2;
    if (pad === last && !wrong) return;
    last = pad;
    document.documentElement.style.setProperty('--kb-ic-pad', pad + 'px');
    var cfg = { alignment: 'left', horizontal_padding: 20, vertical_padding: pad };
    window.intercomSettings = Object.assign(window.intercomSettings || {}, cfg);
    if (typeof window.Intercom === 'function') window.Intercom('update', cfg);
  }
  place();
  setInterval(place, 800);
  window.addEventListener('resize', place);
})();
